import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { Typography, TimePicker } from 'antd';
import type { BaseFieldProps } from '../../../types/form-renderer';
import type { TimeField as TimeFieldType } from '../../../types/templates';

const { Text } = Typography;

type Props = BaseFieldProps<TimeFieldType>;

export const TimeField: React.FC<Props> = ({ field, value, onChange, commonStyle, labelStyle, error }) => {
  const format = 'HH:mm';
  const parsed: Dayjs | null = value ? dayjs(value, format) : null;

  return (
    <div style={commonStyle}>
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase' }}>
        {field.label}
      </Text>
      <TimePicker
        value={parsed}
        format={format}
        minuteStep={5}
        showNow={false}
        onChange={t => onChange(t ? t.format(format) : '')}
        style={{ width: '100%' }}
        placeholder={field.placeholder ?? 'HH:mm'}
        status={error ? 'error' : undefined}
      />
      {error && (
        <Text type='danger' style={{ fontSize: 12, marginTop: 4 }}>
          {error}
        </Text>
      )}
    </div>
  );
};
